// ================================
// src/components/AppShell.tsx — FINAL (Stable Layout)
// - 전역 컨테이너: 하단 패딩은 --banner-h로만 관리
// - 배너 로직 호출은 이 컴포넌트에서 하지 않음
// - 배너 show/hide 반복에도 레이아웃 점프 최소화
// ================================
import React, { PropsWithChildren } from "react";

const AppShell: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      className="app-shell"
      style={{
        minHeight: "100dvh",
        paddingBottom: "max(var(--banner-h, 0px), 64px)",
        background: "#0a0d14",
        color: "#e5eaf3",
      }}
    >
      {children}
    </div>
  );
};

export default AppShell;
